import { render, staticRenderFns } from "./RejectedList.vue?vue&type=template&id=65463adb"
import script from "./RejectedList.vue?vue&type=script&lang=js"
export * from "./RejectedList.vue?vue&type=script&lang=js"
import style0 from "./RejectedList.vue?vue&type=style&index=0&id=65463adb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports